import styled from 'styled-components';

export const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #edf0f5;
  border-radius: 16px;
  overflow: hidden;
  padding: 16px;
`;

export const AccordionHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  background: #edf0f5;
  outline: none;
  border: none;
`;

export const AccordionTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: 0em;
  text-align: left;
`;

export const AccordionActionBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  .toggle {
    background-color: #fff;
    border: 1px solid #c4c4c4;
    height: 32px;
    width: 32px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #616161;
    font-size: 20px;
    cursor: pointer;

    &.opened {
      transform: rotateZ(180deg);
    }
  }
`;

export const AccordionBody = styled.div`
  width: 100%;
  flex: 1;
`;
